
export default function Products() {
  const products = [
    {
      name: 'VPN',
      description: 'Secure and fast VPN solution for iOS devices',
      features: ['Military-grade encryption', 'Global server network', 'No-logs policy', 'Lightning-fast speeds'],
      gradient: 'from-teal-600 to-emerald-600',
      icon: 'ri-shield-check-line',
      image: 'https://public.readdy.ai/ai/img_res/ceb7eab4cc8edb1970312035b9d9b68f.jpg'
    },
    {
      name: 'Cleaner',
      description: 'Optimize and clean your iOS device efficiently',
      features: ['Storage optimization', 'Cache cleaning', 'Battery saver', 'Performance boost'],
      gradient: 'from-emerald-600 to-green-600',
      icon: 'ri-brush-line',
      image: 'https://readdy.ai/api/search-image?query=minimalist-3d-illustration-mobile-phone-cleaning-optimization-icon-emerald-and-green-gradient-background-sparkle-effects-clean-modern-design-floating-geometric-shapes-professional-tech-aesthetic-fresh-look&width=400&height=500&seq=product-cleaner-1&orientation=portrait'
    },
    {
      name: 'Security Suite',
      description: 'Complete security solution for your mobile device',
      features: ['Real-time protection', 'Privacy scanner', 'Secure browsing', 'Data encryption'],
      gradient: 'from-cyan-600 to-teal-600',
      icon: 'ri-lock-line',
      image: 'https://readdy.ai/api/search-image?query=minimalist-3d-illustration-mobile-security-lock-icon-with-fingerprint-cyan-and-teal-gradient-background-digital-protection-concept-clean-modern-design-floating-geometric-shapes-professional-tech-aesthetic&width=400&height=500&seq=product-security-1&orientation=portrait'
    }
  ];

  return (
    <section id="products" className="py-32 bg-gray-900">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="text-center space-y-6 mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
            <i className="ri-apps-line text-teal-400 text-base"></i>
            <span className="text-sm font-medium text-white whitespace-nowrap">Our Products</span>
          </div>
          <h2 className="text-6xl font-bold text-white">
            Enhancing Your iOS Experience
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Discover our suite of applications designed to improve security, performance, and user experience on iOS devices
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className={`group relative rounded-3xl overflow-hidden bg-gradient-to-br ${product.gradient} transition-transform duration-300 hover:scale-105`}
            >
              <div className="aspect-[4/5] relative">
                <div className="absolute inset-0 flex items-center justify-center p-12">
                  <div className="w-full h-full rounded-2xl overflow-hidden">
                    <img 
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/70 to-transparent p-8 pt-32">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl">
                      <i className={`${product.icon} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-3xl font-bold text-white">{product.name}</h3>
                  </div>
                  <p className="text-base text-gray-200 mb-4 leading-relaxed">
                    {product.description}
                  </p>
                  <div className="space-y-2">
                    {product.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <i className="ri-check-line text-sm text-teal-300"></i>
                        <span className="text-sm text-white/90">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}